import React from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import { mdiContentSave, mdiFileSearch } from '@mdi/js';
import Icon from '@mdi/react';

const actions = {
  closeModal,
};

function ModalInfoAdd({ closeModal }) {
  const screenWidth = useScreenWidth();

  return (
    <Modal
      variant='info'
      label='Info'
      closeModal={closeModal}
      width={screenWidth > 900 ? 900 : screenWidth}
    >
      <div className='flex justify-around flex-column align-start mx-5 mb-4'>
        <div className='content pl-2 py-5'>
          <h5>Langkah-Langkah:</h5>
          <div className='preline'>
            <ol>
              <li>Pilih siswa.</li>
              <li>
                Jika pesan menggunakan variabel, maka tambahkan [Angka] yang
                akan digantikan menjadi isian, maka ketikkan pada isi pesan
                seperti contoh ini:
                <br />
                <blockquote>
                  Diberitahukan kepada orang tua [1] untuk segera melunasi SPP
                  bulan [2], sebesar Rp. [3].
                  <br />
                  Harap segera menghubungi admin sekolah untuk detail
                  pembayaran.
                </blockquote>
              </li>
              <li>
                Klik <span className='tag is-rounded is-info mb-1'>+ variabel</span>, dan
                kemudian tambahkan isian sesuai dengan banyaknya variabel yang
                dibuat di isi pesan, dalam hal ini terdapat 3 isian variabel,
                setiap variabel dipisahkan dengan tanda titik koma ";". <br />
                <blockquote>
                  Andi
                  <br />
                  Andi;Juli;100.000
                </blockquote>
              </li>
            </ol>
            <ol>
              Klik pada{' '}
              <span className='tag is-success'>
                <span className='icon is-small'>
                  <Icon path={mdiFileSearch} />
                </span>
              </span>{' '}
              untuk melihat preview pesan, jika preview sudah sesuai klik{' '}
              <span className='tag is-success'>
                <span className='icon is-small'>
                  <Icon path={mdiContentSave} />
                </span>
              </span>{' '}
              untuk menyimpan
            </ol>
          </div>
        </div>
      </div>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalInfoAdd);
